export default __webpack_public_path__ + "static/media/COMB.b109c112.png";